module.exports = __webpack_public_path__ + "img/crm_sem_solution_bg.5d6587c8.png";